import 'swiper/css/bundle';
import Swiper, { EffectFade, Navigation } from 'swiper';
Swiper.use([Navigation, EffectFade]);



import './gallery-carousel.scss';

const galleryCarousel = () => {
    let gallery = {
        slidesPerView: "auto",
        spaceBetween: 10,
        navigation: {
            nextEl: '.gallery-button-next',
            prevEl: '.gallery-button-prev',
        },
        breakpoints: {
            768: {
                spaceBetween: 20, 
            }
        }
    };

    let dsp = {
        slidesPerView: 1,
        spaceBetween: 0,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },

    };



    let gallerySwiper = new Swiper(document.querySelector('.gallerySwiper'), gallery);
    let descriptionSwiper = new Swiper(document.querySelector('.descriptionSwiper'), dsp);
    let counterIndexes = document.querySelectorAll('.counter .index');
    
    gallerySwiper.on('slideChange', function () {
        let currentSlideIndex = gallerySwiper.realIndex;
        descriptionSwiper.slideTo(currentSlideIndex);

        counterIndexes.forEach(element => {
            element.innerHTML = gallerySwiper.realIndex + 1;
        });
    });
    descriptionSwiper.on('slideChange', function () {
        let currentSlideIndex = descriptionSwiper.realIndex;
        gallerySwiper.slideTo(currentSlideIndex);
    });
}

export default galleryCarousel;